Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "GogWrapper3072024955",
  {"root":"GogWrapper3072024955--root"},
  "",
  1,
  "GogWrapper3072024955"
);

